<template>
    <section class="section-padding bg-light-gray" id="moji-kuponi">
        <h2 class="text-center">Moji kuponi</h2>

        <div
            class="container-page d-flex gap-5 flex-column flex-lg-row align-items-center justify-content-between py-4"
        >
            <img
                width="588"
                height="699"
                loading="lazy"
                class="img-fluid order-1 order-lg-0 max-w-sm"
                src="/img/application/original/coupons.webp"
                sizes="(min-width: 768px) 768px, 100vw"
                srcset="
                    /img/application/sm/coupons.webp   384w,
                    /img/application/lg/coupons.webp   512w,
                    /img/application/3xl/coupons.webp  768w,
                    /img/application/5xl/coupons.webp 1024w,
                    /img/application/7xl/coupons.webp 1280w,
                    /img/application/8xl/coupons.webp 1536w,
                    /img/application/9xl/coupons.webp 1920w
                "
                alt="Kuponi"
            />
            <p class="max-w-sm pt-2 pb-1 py-md-3 py-lg-5">
                <strong>
                    Nova verzija Euro Petrol aplikacije donosi ti još jednu
                    važnu pogodnost, mogućnost da ostvariš kupon za gratis
                    proizvod.
                </strong>
                U zavisnosti od aktivne promocije u šopu, kupovinom određenog
                broja proizvoda sledeći dobijaš gratis. <br /><br />
                Na primer, ako je aktivna akcija za kafu 5 + 1 gratis, nakon
                kupovine pete kafe u aplikaciji ti se automatski kreira kupon.
                Prilikom sledeće posete Euro Petrol benzinskoj stanici, dovoljno
                je da skeniraš aplikaciju i svoju narednu kafu dobijaš gratis.
                <br /><br />
                Proizvodi za koje možeš ostvariti kupon zavise od trenutno
                aktivnih promocija. U aplikaciji u svakom trenutku možeš da
                vidiš za koje proizvode možeš da prikupljaš kupovine i ostvariš
                gratis kupon.
            </p>
        </div>
    </section>
</template>

<style scoped>
img {
    width: 36.75rem;
}

@media (max-width: 768px) {
    img {
        width: 100%;
    }
}
</style>
